import { keyMirror } from "../../../utils";

export default keyMirror(['SET_ROUTES', 'CHANGE_ROUTE']);
